<template>
  <LoginDialog
    v-show="showLogin"
    moduleName="经营帮"
    :custom="true"
    :showLogin="showLogin"
    :Authorization="authToken"
    iosPath="https://shigongbang.obs.cn-east-3.myhuaweicloud.com/0IY-In2q5TJxj4lk-exVX.png"
    androidPath="https://shigongbang.obs.cn-east-3.myhuaweicloud.com/1FgzjhZQi-ZZp7bYE_hov.png"
    :downloadWindow="true"
    :activeCode="1"
    :downloadURL="downURL"
    :closeOnPressEscape="true"
    @send-data="getSendData"
    @close-dialog="() => (this.showLogin = false)"
  >
    <template>
      <p class="description-text">
        <span>数字应用</span>
        <span>数字服务</span>
        <span>助您成功</span>
      </p>
    </template>
  </LoginDialog>
</template>

<script>
import cookie from "@/storage/cookies";
import { syncCookieToken } from "@/utils/asyncToken";
import store from "@/store";
import {getOS,getDownLoad} from '@/utils/downloadApp.js'

const LOGIN_AUTH = "Basic MTE3NTI3Njk0NDMyNjAwNDczNjo2M2NkMzYwM2Q5YTc0ZTNiYmI4ZDhiOGE5NmQ3MWVlZA==";

const JYB_DOWNURL = getDownLoad(getOS()) || "https://zjkj-sgb-manager-client.obs.cn-east-3.myhuaweicloud.com/jyb/经营帮客户端.exe";

export default {
  name: "CommonLogin",
  data() {
    return {
      showLogin: true,
      authToken: LOGIN_AUTH,
      downURL: JYB_DOWNURL,
      callBack: function() {},
      closeCallBack: function() {}
    };
  },
  methods: {
    async getSendData(token) {
      if (!token) {
        this.$_toast({
          type: "error",
          msg: "登录失败，请联系管理员!",
          time: 3000,
        });
        return;
      }
      cookie.cookieSet("token", token);
      store.commit("SET_TOKEN", token);
      await syncCookieToken();
      this.close(true)
    //   location.reload();
    },
     close(bol) {
      this.showLogin = false
      if (bol) {
        // 确定回调
        this.callBack()
      }
      if (bol === false) {
        // 取消回调
        this.closeCallBack()
      }
      this.$destroy(true)
      this.$el.parentNode.removeChild(this.$el)
    },
  },
};
</script>
<style lang="scss" scoped>
.description-text {
    font-size: 18px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: 700;
    color: #fff;
    text-shadow: 0 2px 4px rgba(109, 76, 23, 36%);
    padding: 16px 0;
    margin: 0;
    span {
      padding-right: 24px;
    }
}
</style>
<style  lang="scss">
.login-box{
    .input-img-box,.password-input-img-box ,.sms-input-img-box, .short-input-img-box{
        height: 38px;
    }
}</style>